import { set, get } from 'lodash';
import ApplicationService from '@/services/applications/ApplicationService';
import DocumentService from '@/services/applications/DocumentService';

// initial state
// shape: [{ id, quantity }]
const application = {
  state: {
    documentTypes: [],
    loadedApplications: null,
    loadedApplication: {
      subject: null,
      address: {},
      application_type: {},
      file: {},
      created_by: {},
      documents: [],
      intimations: [],
      payment_slips: [],
      locked_by: null,
      locked_at: null,
      person: {
        address: {},
      },
      typology: {},
    },
  },
  mutations: {
    ADD_NEW_SUBPOENA: (state, subpoena) => {
      set(state, 'newSubpoena', subpoena);
    },
    SET_LOADED_APPLICATIONS: (state, applications) => {
      set(state, 'loadedApplications', applications);
    },
    SET_SINGLE_APPLICATION: (state, fetchedApplication) => {
      set(state, 'loadedApplication', fetchedApplication);
    },
    SET_DOCUMENT_TYPES_LIST: (state, documentTypes) => {
      set(state, 'documentTypes', documentTypes);
    },
    SET_DOCUMENTS_APPLICATION: (state, documents) => {
      set(state.loadedApplication, 'documents', documents);
    },
    SET_INTIMATIONS_APPLICATION: (state, intimations) => {
      set(state.loadedApplication, 'intimations', intimations);
    },
    SET_DOCUMENT_APPLICATION: (state, documents) => {
      set(state.loadedApplication, 'documents', documents);
    },
    UPDATE_DOCUMENT: (state, document) => {
      const documents = state.loadedApplication.documents.map((d) => {
        if (d.id === document.id) {
          return document;
        }
        return d;
      });
      const intimations = state.loadedApplication.intimations.map((i) => {
        const docs = i.documents.map((d) => {
          if (d.id === document.id) {
            return document;
          }
          return d;
        });
        const intimation = Object.assign({}, i);
        intimation.documents = docs;
        return intimation;
      });
      set(state.loadedApplication, 'documents', documents);
      set(state.loadedApplication, 'intimations', intimations);
    },
    SET_LOCKED: (state, lockedBy, lockedAt) => {
      set(state.loadedApplication, 'locked_by', lockedBy);
      set(state.loadedApplication, 'locked_at', lockedAt);
    },
  },
  actions: {
    async fetchApplication({ commit }, applicationId) {
      const response = await ApplicationService.fetchApplication(applicationId);
      commit('SET_SINGLE_APPLICATION', response.data);
    },
    async fetchApplications({ commit },{per_page, page, status}) {
      const response = await ApplicationService.fetchApplications(per_page,page,status);
      commit('SET_LOADED_APPLICATIONS', response.data);
    },
    async searchApplications({ commit },{per_page, page, search}) {
      const response = await ApplicationService.searchApplications(per_page,page,search);
      console.log(response.data);
      commit('SET_LOADED_APPLICATIONS', response.data);
    },
    // async searchAdminApplications({ commit },{per_page, page, status, search}) {
    //   const response = await ApplicationService.searchApplications(per_page,page,status,search);
    //   commit('SET_LOADED_APPLICATIONS', response.data);
    // },
    async adminFetchApplication({ commit }, applicationId) {
      const response = await ApplicationService.adminFetchApplication(applicationId);
      commit('SET_SINGLE_APPLICATION', response.data);
    },
    async adminFetchApplications({ commit },{per_page, page, status}) {
      const response = await ApplicationService.adminFetchApplications(per_page,page,status);
      commit('SET_LOADED_APPLICATIONS', response.data);
    },
    async sendNewDocumentVersion({ commit }, params) {
      const newDocument = get(params, 'document');
      let documents = get(params, 'documents');
      documents = documents.map((d) => {
        if (d.id === newDocument.id) {
          return newDocument;
        }
        return d;
      });
      commit('SET_DOCUMENTS_APPLICATION', documents);
    },
    async sendNewDocumentVersionIntimated({ commit }, params) {
      const newDocument = get(params, 'document');
      const intimations = get(params, 'intimations');
      intimations.forEach((i, indexIntimation) => {
        i.documents.forEach((d, indexDocument) => {
          if (d.id === newDocument.id) {
            intimations[indexIntimation].documents[indexDocument] = newDocument;
          }
        });
      });
      commit('SET_INTIMATIONS_APPLICATION', intimations);
    },
    async sendApplicationToReview({ commit }, fetchedApplication) {
      const response = await ApplicationService.sendApplicationToReview(fetchedApplication);
      commit('SET_SINGLE_APPLICATION', response.data);
    },
    async finishReview({ commit }, fetchedApplication) {
      const response = await ApplicationService.finishReview(fetchedApplication);
      commit('SET_SINGLE_APPLICATION', response.data);
    },
    async startAnalysis({ commit }, applicationId) {
      const response = await ApplicationService.startAnalysis(applicationId);
      commit('SET_LOCKED', response.data.locked_by, response.data.locked_at);
    },
    async approveDocument({ commit }, payload) {
      const response = await DocumentService.approveDocument(payload);
      commit('UPDATE_DOCUMENT', response.data);
    },
    async undoAnalysis({ commit }, payload) {
      const documentId = payload.document.id;
      const applicationId = payload.application.id;
      const response = await DocumentService.undoAnalysis(documentId, applicationId);
      commit('UPDATE_DOCUMENT', response.data);
    },
    async disapproveDocument({ commit }, payload) {
      const response = await DocumentService.disapproveDocument(payload);
      commit('UPDATE_DOCUMENT', response.data);
    },
    emptyApplications({ commit }) {
      commit('SET_LOADED_APPLICATIONS', []);
      commit('SET_SINGLE_APPLICATION', {});
    },
    async fetchDocumentTypes({ commit }) {
      const response = await DocumentService.fetchDocumentTypes();
      commit('SET_DOCUMENT_TYPES_LIST', response.data);
    },
    async createSubpoena({ commit }, payload) {
      const response = await ApplicationService.createSubpoena(
        payload.applicationId,
        payload.intimation,
      );
      commit('ADD_NEW_SUBPOENA', response.data);
    },
  },
};
export default application;
